<template>
  <div>
    <SideBar></SideBar>
    <!--<div class="banner"></div>-->
    <div class="main">
      <div class="con-box">
        <div class="right-con"
             v-if="isSelect===0">
          <h3 class="rescue-bigtitle">总经理致辞</h3>
          <img class="img1"
               src="../assets/images/company/1.png" />
          <h5>威马捷总经理 千代 隆明</h5>
          <p>无论您身处世界何地， 威马捷随时随地为您提供服务。北京威马捷国际旅行援助有限责任公司作为日本威马捷救援株式会社集团的一员，在医疗健康,工作旅行，生活方式等各个领域提供安全支持,为您安心无忧地活跃于世界各地保驾护航。我们的宗旨是 “广阔世界，伴您同行”，为您在不同的国度和文化环境中的旅行、工作、生活提供安心的救援服务。
          </p>
          <p class="bottom"> 威马捷通过大数据背景下的智能化最新型的援助，不只是为中国客户，包括亚洲以及世界各国的客户提供服务。 我们致力于让援助成为顾客生活方式的一部分。为此，我们将不断面对挑战，全力以赴完成我们的使命。</p>
        </div>
        <div class="right-con"
             v-if="isSelect===1">
          <h3 class="rescue-bigtitle">公司概要</h3>
          <div class="list">
            <div class="item-box">
              <span>统一社会信用代码</span>
              <span>911101057526075933</span>
            </div>
            <div class="item-box">
              <span>名称</span>
              <span>北京威马捷国际旅行援助有限责任公司</span>
            </div>
            <div class="item-box">
              <span>类型</span>
              <span>有限责任公司（外国法人独资）</span>
            </div>
            <div class="item-box">
              <span>住所</span>
              <span>北京市朝阳区东四环中路56号远洋国际中心A座23层2303-05</span>
            </div>
            <div class="item-box">
              <span>法定代表人</span>
              <span>仓田洁</span>
            </div>
            <div class="item-box">
              <span>注册资本</span>
              <span>美元25万元</span>
            </div>
            <div class="item-box">
              <span>成立日期</span>
              <span>2003年07月28日</span>
            </div>
            <div class="item-box">
              <span>营业期限</span>
              <span>2003年07月28日至2023年07月27日</span>
            </div>
            <div class="item-box">
              <span>经营范围</span>
              <span>旅行援助（联络）服务；旅行援助信息咨询服务；医疗信息咨询（不含诊 疗及中介活动）；健康咨询（须经审批的诊疗活动除外）；健康管理</span>
            </div>
            <div class="item-box">
              <span>代表电话</span>
              <span>010-8592-7001 （24H） </span>
            </div>
            <div class="item-box">
              <span>传真号码</span>
              <span>010-8586-6426 </span>
            </div>
            <div class="item-box">
              <span>URL</span>
              <span>http://weimajie.com.cn/ </span>
            </div>
          </div>
          <!--<h4 class="rescue-title">威马捷组织说明</h4>
          <img class="img2"
               src="../assets/images/company/2.png" />-->
        </div>
        <div class="right-con"
             v-if="isSelect===2">
          <h3 class="rescue-bigtitle">集团公司信息</h3>
          <div class="list">
            <div class="item-box">
              <span>母公司名</span>
              <span>Emergency Assistance Japan Co., Ltd. </span>
            </div>
            <div class="item-box">
              <span>成立日</span>
              <span>2003年01月16日</span>
            </div>
            <div class="item-box">
              <span>母公司地址</span>
              <span>〒112-0002東京都文京区小石川1丁目21番14号 NRK小石川大厦 </span>
            </div>
            <div class="item-box">
              <span>TEL</span>
              <span>03-3811-8121（代表）</span>
            </div>
            <div class="item-box">
              <span>FAX</span>
              <span>03-3811-8122</span>
            </div>
            <div class="item-box">
              <span>URL</span>
              <span>http://emergency.co.jp</span>
            </div>
            <div class="item-box">
              <span>公司人数</span>
              <span>288名（2018年12月31日为止）</span>
            </div>
            <div class="item-box">
              <span>资本金</span>
              <span>303百万円</span>
            </div>
            <div class="item-box">
              <span>结算年</span>
              <span>12月结算 </span>
            </div>
            <div class="item-box">
              <span>上市</span>
              <span>东京证券交易所　JASDAQ<br/> 股票号码：6063（2012年6月20日上市） </span>
            </div>
            <div class="item-box">
              <span>拥有资质</span>
              <span>医疗签证担保机构 登录管理号 B-001<br/> 个人信息保护认证 登录号 第10862174（01）号<br/> 東京都知事登録旅行業 第3-5955号<br/> 医療旅行支援企业 认证号 MEJ-AMTAC-002

              </span>
            </div>
          </div>
          <h4 class="rescue-title">EAJ全球</h4>
          <ul class="customer-list">
            <li>
              <span class="icon">•</span>
              <span class="text">东京·大阪+全球10个直属分公司。</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">全球约310名员工，其中半数为呼叫中心客服及医疗团队人员。</span>
            </li>
          </ul>
          <img class="img3"
               src="../assets/images/company/4.jpg" />
          <img class="img4"
               src="../assets/images/company/3.jpg" />
        </div>
        <div class="right-con self-con"
             v-if="isSelect===3">
          <h4 class="rescue-bigtitle">个人信息保护原则</h4>
          <p> 本公司在提供服务过程中获取的您的个人信息，本公司将按照个人信息保护法或其他法令予以妥善保管。请您务必认真阅读以下内容。
          </p>
          <p> １．个人信息管理 <br/> 您所提供的个人信息，将由以下人员负责管理。 <br/> 负责管理的公司：北京威马捷国际旅行援助有限责任公司
            <br/> 联系人：个人信息保护负责人
            <br/> 邮政编码： 100025<br/> 地 址：北京市朝阳区东四环中路56号 远洋国际中心A座23层03-05<br/> 联系电话： 010-85927001（总机）<br/> 电子邮箱： ejc-info@emergency.co.jp<br/> 接待时间： 9：00-17：00（周六，周日及节假日除外）
          </p>
          <p style="margin-bottom:0!important;"> ２．使用个人信息的目的 <br/> 本公司将获取的个人信息主要用于本公司开展的以下【１】所述业务范围内，并仅限于以下【2】所述使用目的。除法令另有规定外，将不会用于本同意书所述目的之外，为此将采取必要措施。 </p>
          <h3>【１】 业务内容 <br/> ① 医疗信息咨询业务；② 健康咨询业务；③ 健康管理业务；④ 旅行援助（联络）业务；⑤ 旅行援助信息咨询业务；⑥ 企业策划业务；⑦ 承办展览展示业务；⑧ 上述各项业务附带的所有业务（包括但不限于医疗翻译，代订车辆，代订酒店，代订餐饮等）
            <br/>
          </h3>

          <h3>【２】使用目的 <br/> ① 为进行与上述业务相关的合理业务使用个人信息，比如，提供所申请的服务、进行各种联络、 处理账单及结算、接待询问及委托等 <br/> ② 为开展与上述业务相关的工作使用个人信息，比如，告知商品及服务信息、提供情报、进行问卷调查、数据积累及分析 <br/> ③ 为妥善且圆满执行受其他企业委托的业务
          </h3>
          <p style="margin-top:10px;">3．关于提供给第三方<br/> 除以下情况外，本公司不会在未经您同意的情况下，擅自将您的个人信息提供给第三方。<br/> ① 按个人信息保护法或其他法令的规定使用按个人信息保护法或其他法令的规定使用时
            <br/> ② 在本公司执行业务所必要的范围内，提供给包括当地业务合作公司在内的受托方时<br/> ③ 与本公司的集团公司、合作企业共同使用时

          </p>
          <p>4．关于委托 <br/> 本公司有可能在处理业务时向已与本公司签订保密协议的合作公司进行业务委托。
          </p>
          <p>5．敏感信息的处理 <br/> 本公司绝对不会将健康状态及病历等敏感信息擅自获取、利用或提供给第三方。个人信息保护法或其他法令、指导方针另有规定时不受此限制。
          </p>
          <p>
            ６．关于公开个人信息<br/> 在您要求本公司对您已提供给本公司的个人信息进行公开、修改、追加或删除、停止使用、清除及停止提供给第三方使用时，本公司将采取相应措施。
          </p>
        </div>
        <div class="left-menu">
          <div class="left-menu-box">
            <p v-for="(item,index) in titleArr"
               :key="index"
               @click="selectName(index)"
               :class="['left-menu-title',{'selet':index===isSelect}]">
              <span>
              </span>
              {{item}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SideBar from "@/components/SideBar"
import * as apis from '@/api/success';
export default {

  data () {
    return {
      accord: '0',
      titleArr: ['总经理致辞', '公司概要', '集团公司信息', '个人信息保护'],
      isSelect: 0
    }
  },
  components: {
    // Bread
    SideBar
  },
  mounted () {
  },
  methods: {
    selectName (index) {
      this.isSelect = index
    }
  }
}
</script>
<style lang="less" scoped>
.rescue-bigtitle {
  position: relative;
  width: 100%;
  height: 80px;
  background: url('../assets/images/title-bg.png') no-repeat center center;
  background-size: 100% 100%;
  color: #fff;
  font-size: 28px;
  line-height: 80px;
  padding-left: 45px;
  margin-bottom: 60px;
}
.banner {
  height: 250px;
  background: #d3dbe8;
  // margin-bottom: 60px;
  // background: url('../assets/images/successCase/banner.png') no-repeat center;
}
.main {
  width: 100% !important;
  margin: 0 auto;
  background: #fff;
  padding-top: 60px;
  .con-box {
    width: 980px;
    margin: 0 auto;
    display: table;
  }
}
.bread {
  margin: 50px auto 30px;
}
.left-menu {
  width: 240px;
  background-color: #333130;
  box-sizing: border-box;
  padding: 21px 10px;
  float: left;
  .left-menu-box {
    background: #fff;
  }
}
.right-con {
  float: left;
  width: 709px;
  margin-right: 30px;
  .rescue-title {
    position: relative;
    font-size: 24px;
    line-height: 23px;
    padding-bottom: 15px;
    font-weight: bold;
    color: #333130;
    border-bottom: 3px solid #ae1e10;
    margin-bottom: 40px;
    padding-top: 0px;
    &::after {
      position: absolute;
      left: 0;
      bottom: 0;
      display: block;
      content: '';
      width: 320px;
      height: 2px;
      background: #ae1e10;
    }
  }

  .img1 {
    width: 706px;
    height: 397px;
  }
  h5 {
    font-size: 14px;
    color: #333130;
    font-weight: none;
    margin: 20px 0 37px 0;
    text-align: center;
  }
  p {
    line-height: 32px;
    font-size: 16px;
    color: #333130;
    text-indent: 2em;
    margin-bottom: 20px;
  }
  .bottom {
    padding-bottom: 250px;
  }
  .list {
    margin-bottom: 102px;
    .item-box {
      display: table;
      width: 709px;
      padding: 17px 0;
      border-bottom: 1px solid #d8d8d8;
      span {
        display: table-cell;
        vertical-align: middle;
        font-size: 16px;
        // display: inline-block;
        line-height: 24px;
      }
      span:first-child {
        width: 197px;
      }
      span:last-child {
        width: 512px;
      }
      &:first-child {
        padding-top: 0;
      }
    }
  }
  .img2 {
    width: 708px;
    height: 425px;
    margin-bottom: 100px;
  }
  .customer-list {
    li {
      font-size: 16px;
      line-height: 32px;
      display: table;
      width: 100%;
      span {
        display: block;
        float: left;
      }
      .icon {
        width: 21px;
        text-align: left;
        font-size: 30px;
        color: #ae1e10;
      }
      .text {
        font-size: 16px;
        margin-left: 2px;
        color: #333130;
      }
    }
  }
  .img3 {
    width: 709px;
    height: 297px;
    margin-top: 29px;
    background: rgba(211, 219, 232, 1);
  }
  .img4 {
    width: 709px;
    height: 485px;
    margin: 40px 0 100px 0;
  }
}
.self-con {
  p {
    text-indent: 0 !important;
  }
  h3 {
    font-size: 15px;
    font-weight: normal;
    line-height: 32px;
    color: #333130;
    margin-top: 6px;
  }
}
.left-menu-title {
  position: relative;
  // width: 210px;
  font-size: 20px;
  color: #333130;
  padding-left: 38px;
  box-sizing: border-box;
  padding: 24px 0 24px 50px;
  border-bottom: 2px solid #333130;
  cursor: pointer;
  &:last-child {
    border-bottom: none;
  }
  span {
    width: 8px;
    height: 8px;
    border-top: 1px solid #333130;
    border-right: 1px solid #333130;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    position: absolute;
    left: 14px;
    top: 34px;
  }
}
.selet {
  background: #ae1e10;
  color: #fff;
  span {
    width: 8px;
    height: 8px;
    border-top: 1px solid #fff;
    border-right: 1px solid #fff;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    position: absolute;
    left: 14px;
    top: 34px;
  }
}
.submenu {
  font-size: 18px;
  color: #333130;
  line-height: 50px;
  border-bottom: 1px solid #f6f6f6;
  padding-left: 20px;
  a {
    display: block;
    color: #333130;
  }
  .router-link-active {
    background: url('../assets/images/successCase/icon-pointer.png') no-repeat
      150px center;
  }
}
</style>
<style>
.ivu-collapse-content {
  padding: 0;
}
.ivu-collapse-content > .ivu-collapse-content-box {
  padding: 0;
}
.ivu-collapse > .ivu-collapse-item > .ivu-collapse-header {
  height: 60px;
  font-size: 24px;
  color: #ae1e10;
  line-height: 60px;
}
.ivu-collapse-header .ivu-icon {
  float: right;
  margin-top: 6px;
}
</style>

